import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';

// Pages
import HomePage from './pages/HomePage';
import ContactFormPage from './pages/ContactFormPage';
import SurveyFormPage from './pages/SurveyFormPage';
import RegistrationFormPage from './pages/RegistrationFormPage';
import CustomizationPage from './pages/CustomizationPage';
import ApiIntegrationPage from './pages/ApiIntegrationPage';
import MultiStepFormPage from './pages/MultiStepFormPage';

const App = () => {
  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-title">BoilerWorks TypeForms</div>
        <nav>
          <ul className="sidebar-nav">
            <li className="sidebar-nav-item">
              <NavLink 
                to="/" 
                className={({ isActive }) => 
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
                end
              >
                Home
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/contact-form"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                Contact Form
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/survey-form"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                Survey Form
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/registration-form"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                Registration Form
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/multi-step-form"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                Multi-Step Form
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/customization"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                Customization
              </NavLink>
            </li>
            <li className="sidebar-nav-item">
              <NavLink
                to="/api-integration"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-link active" : "sidebar-nav-link"
                }
              >
                API Integration
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>
      
      <main className="content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact-form" element={<ContactFormPage />} />
          <Route path="/survey-form" element={<SurveyFormPage />} />
          <Route path="/registration-form" element={<RegistrationFormPage />} />
          <Route path="/multi-step-form" element={<MultiStepFormPage />} />
          <Route path="/customization" element={<CustomizationPage />} />
          <Route path="/api-integration" element={<ApiIntegrationPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default App; 